import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { createIntegrationConnectionsQueryOptions } from 'v2/pages/settings/integrations/connection-queries'
import { settingsService } from '../services/settings-service'
import { getSettingsQueryKeys } from '../utils/query-key-management'

export const Prefetcher = () => {
  const queryClient = useQueryClient()

  useEffect(() => {
    queryClient.prefetchQuery({
      ...createIntegrationConnectionsQueryOptions(),
      meta: { silent: true },
    })
  }, [queryClient])

  useEffect(() => {
    queryClient.prefetchQuery({
      queryKey: getSettingsQueryKeys().users,
      meta: { silent: true },
      queryFn: async () => {
        const response = await settingsService.getUsersList({})
        return response.data
      },
    })
  }, [])

  return null
}
